import { useState } from "react";
import type { StepDetailProps } from "./index";
import { STEP_OUTPUT_SCHEMAS, zodIssuesToErrors } from "./schemas";
import { StepActions } from "./StepActions";

export function InstrumentationDetail({
  step,
  play,
  workspaceId,
  currentUserId,
  persona,
}: StepDetailProps) {
  const metric =
    typeof step.inputs["metric"] === "string"
      ? (step.inputs["metric"] as string)
      : "—";
  const threshold =
    typeof step.inputs["threshold"] === "number"
      ? (step.inputs["threshold"] as number)
      : null;
  const window_ =
    typeof step.inputs["window"] === "string"
      ? (step.inputs["window"] as string)
      : null;

  const [value, setValue] = useState<string>("");
  const [errors, setErrors] = useState<Record<string, string>>({});

  const buildOutput = (): Record<string, unknown> | null => {
    const payload = {
      measured_value: value,
      measured_at: new Date().toISOString(),
    };
    const parsed = STEP_OUTPUT_SCHEMAS["instrumentation"].safeParse(payload);
    if (!parsed.success) {
      const map: Record<string, string> = {};
      for (const e of zodIssuesToErrors(parsed.error)) map[e.path] = e.message;
      setErrors(map);
      return null;
    }
    setErrors({});
    return parsed.data as Record<string, unknown>;
  };

  return (
    <div
      className="ho-detail ho-quiet"
      data-testid="step-detail-instrumentation"
    >
      <div className="ho-eb">INSTRUMENTATION · TRACKING</div>
      <h2 className="ho-h2">{step.title}</h2>
      <div className="ho-meta-row">
        <span className="pill">{metric}</span>
        {threshold !== null ? (
          <span className="pill">threshold: {threshold}</span>
        ) : null}
        {window_ ? <span className="pill">window: {window_}</span> : null}
      </div>
      <div className="ho-quiet-b">
        <div className="ho-quiet-h">PASSIVE TELEMETRY</div>
        <div className="ho-quiet-s">
          XAMI is capturing this metric continuously. Manual entry below for
          one-shot captures.
        </div>
      </div>

      {step.state === "running" ? (
        <div style={{ display: "grid", gap: 8, marginTop: 12 }}>
          <label>
            <span
              style={{
                fontSize: 11.5,
                color: "var(--text-3)",
                letterSpacing: ".14em",
              }}
            >
              MEASURED VALUE
            </span>
            <input
              type="number"
              step="any"
              data-testid="instrumentation-value"
              value={value}
              onChange={(e) => setValue(e.target.value)}
              style={{
                marginTop: 4,
                width: "100%",
                border: "1px solid var(--border)",
                borderRadius: 6,
                padding: 8,
              }}
            />
          </label>
          {errors["measured_value"] ? (
            <span
              style={{ color: "var(--danger)", fontSize: 12 }}
              data-testid="instrumentation-error"
            >
              {errors["measured_value"]}
            </span>
          ) : null}
        </div>
      ) : null}

      <StepActions
        step={step}
        workspaceId={workspaceId}
        playId={play.id}
        campaignId={play.campaignId ?? null}        currentUserId={currentUserId}
        persona={persona}
        buildOutput={buildOutput}
      />
    </div>
  );
}
